var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M1.118 1.618h7.764v7.764M8.646 1.854L1.354 9.146"})));
}

Link.defaultProps = {"viewBox":"0 0 10 11"};

module.exports = Link;

Link.default = Link;
